"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clipboardTextToLinkedRecord = void 0;
const linked_record_fieldtype_1 = require("../fields/linked-record-field/linked-record.fieldtype");
const clipboard_1 = require("./clipboard");
const utils_1 = require("./utils");
const record_1 = require("../utils/record");
const clipboardTextToLinkedRecord = (appRecordsService) => {
    return async (clipboardValue, _srcField, targetField, _userPreferences, currentValue) => {
        const text = clipboardValue.text.replace(/\n/g, " ").trim();
        if (!text) {
            return targetField.params.required ? currentValue : [];
        }
        const titles = (0, utils_1.processClipboardTextValueWithSeparators)(clipboardValue);
        if (!titles.length && targetField.params.required) {
            return targetField.params.required ? currentValue : [];
        }
        const textHasSeparators = titles.length > 1;
        if (textHasSeparators) {
            titles.push(text);
        }
        const records = await appRecordsService.recordsByTitleService.fetchRecordsByTitles(targetField.params.linked_application, titles);
        const fullTextMatchedRecord = records.find((record) => (0, record_1.getTitle)(record).toLocaleLowerCase() === text.toLocaleLowerCase());
        if (fullTextMatchedRecord) {
            return processRecords([fullTextMatchedRecord], targetField, appRecordsService, currentValue);
        }
        return processRecords(records, targetField, appRecordsService, currentValue);
    };
};
exports.clipboardTextToLinkedRecord = clipboardTextToLinkedRecord;
const processRecords = (records, targetField, appRecordsService, currentValue) => {
    const symmetricField = (0, linked_record_fieldtype_1.getSymmetricField)(targetField, appRecordsService);
    const recordIds = (0, clipboard_1.clipboardForTextToLinkedRecordField)(records, targetField, symmetricField);
    if (recordIds.length === 0) {
        return currentValue || [];
    }
    return recordIds;
};
